import store from '@/store';
import { isEmpty } from '@/common/utils/Util';
import { showTextModal } from '@/common/utils/ModalState';

// 260608 이벤트 가입(커피 쿠폰) — 별도 진입점 없이 비즈니스 등록(registerNew)에 묻어가는 옵인.
//   여기 라우트는 발급된 쿠폰을 보는 "내 쿠폰" 화면만. 진입은 등록 완료 모달 등에서.
//   계약 전 — coffeeEventEnabled(default 0) flag off면 준비중 모달 + 차단(룰 55).

// 진입 가드: feature flag off면 준비중 모달 + 차단 (BusinessPath custom-order 패턴 동일).
const requireCoffeeEventFlag = async (to, from) => {
  await store.dispatch('common/fetchFeatureFlags', { force: true });
  const flags = store.getters['common/getFeatureFlags'];
  if (!flags?.coffeeEventEnabled) {
    showTextModal('이벤트는 현재 준비중이에요.\n곧 만나뵐게요.', '확인');
    return from?.name ? false : '/main';
  }
};

// 로그인 가드 — 미로그인 시 '/signin' 반환(beforeEnter가 navigation 자체를 리다이렉트해 화면 mount/인증 API 선발사 방지).
const requireLogin = () => {
  const user = store.getters['user/getUserData'];
  if (isEmpty(user.userNo)) return '/signin';
};

export default [
  {
    // 내 쿠폰 — 직원 확인 버튼(소멸). flag + 로그인 둘 다 가드.
    path: '/event/coupon',
    name: 'event-coupon',
    component: () => import('@/views/event/eventCoupon.vue'),
    meta: { isHeader: true, isNav: false, isBack: true, titleName: '내 쿠폰' },
    beforeEnter: async (to, from) => {
      const blocked = await requireCoffeeEventFlag(to, from);
      if (blocked !== undefined) return blocked;
      return requireLogin();
    }
  },
  {
    // 260608 공유코드 — 발급자 코드 발급/공유 + 보상 현황. flag + 로그인 가드(사업장 무관, 계정당 1코드).
    // 슈퍼배터리 '기업 성장시키기' 타일이 flag ON 시 이 화면으로 대체됨(ChargeHub).
    path: '/event/share',
    name: 'event-share',
    component: () => import('@/views/event/eventShare.vue'),
    meta: { isHeader: true, isNav: false, isBack: true, titleName: '메가 커피쿠폰 공유' },
    beforeEnter: async (to, from) => {
      const blocked = await requireCoffeeEventFlag(to, from);
      if (blocked !== undefined) return blocked;
      return requireLogin();
    }
  }
];
